import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBranding } from '../../branding/BrandingContext';
import { logoutUser } from '../../services/session';
import './CheckoutResult.css';

const RestaurantInactive = () => {
  const navigate = useNavigate();
  const branding = useBranding();
  const isAtendabotBrand = branding?.key === 'atendabot';

  const handleLogout = async () => {
    await logoutUser();
    navigate('/login');
  };

  return (
    <div className="checkout-result">
      <div className="checkout-card">
        <span className="checkout-badge is-failure">
          {isAtendabotBrand ? 'Conta inativa' : 'Restaurante inativo'}
        </span>
        <h1>Seu acesso está bloqueado</h1>
        <p>
          {isAtendabotBrand
            ? 'A conta vinculada ao seu acesso está inativa. Entre em contato com o administrador para reativá-la.'
            : 'O restaurante vinculado a sua conta está inativo. Entre em contato com o administrador para reativar o acesso.'}
        </p>
        <div className="checkout-actions">
          <button className="secondary" type="button" onClick={handleLogout}>
            Sair
          </button>
        </div>
      </div>
    </div>
  );
};

export default RestaurantInactive;
